// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updatePaymentRequestByClient } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitUpdateJobPaymentApi = createAsyncThunk("hitUpdateJobPaymentApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("clientToken")}`,
      },
    };
    const url = ApiBaseUrl + updatePaymentRequestByClient;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const UpdateJobPaymentClientSlice = createSlice({
  name: "updateJobPaymentClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearUpdateJobPaymentClientSliceData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdateJobPaymentApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdateJobPaymentApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdateJobPaymentApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearUpdateJobPaymentClientSliceData } = UpdateJobPaymentClientSlice.actions;
export default UpdateJobPaymentClientSlice.reducer;
